import { render, staticRenderFns } from "./CartTabMenu.vue?vue&type=template&id=5031cd16&scoped=true"
import script from "./CartTabMenu.vue?vue&type=script&lang=ts"
export * from "./CartTabMenu.vue?vue&type=script&lang=ts"
import style0 from "./CartTabMenu.vue?vue&type=style&index=0&id=5031cd16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5031cd16",
  null
  
)

export default component.exports